import React from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { XIcon } from 'lucide-react'

import { JsonDisplay } from './JsonDisplay'

interface SchemaModal {
  input: string
  output: string
  description: string
}

export const SchemaModal: React.FC<SchemaModal> = ({
  input,
  output,
  description,
}) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <button
          type="button"
          className="rounded-md border border-transparent bg-purple-700 px-4 py-[6px] text-[14px] text-white shadow-sm hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
        >
          View Schema
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-black/50 fixed inset-0 z-[9999]" />
        <Dialog.Content className="fixed left-[50%] top-[50%] z-[10000] flex h-[90vh] min-h-[92vh] min-w-[85vw] translate-x-[-50%] translate-y-[-46%] flex-col justify-start !space-y-0 !rounded-t-[30px] bg-[#fff] px-0 py-0 shadow-xl ring-1 ring-gray-200 focus:outline-none">
          <div className="mb-6 flex items-center justify-between px-6 pt-6">
            <Dialog.Title className="text-xl font-semibold text-gray-900">
              API Schema Details
            </Dialog.Title>
            <Dialog.Close
              className="absolute right-[20px] top-[22px]"
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <XIcon className="h-[16px] w-[16px]" />
            </Dialog.Close>
          </div>

          <div
            className="space-y-8 overflow-y-auto px-6"
            style={{ maxHeight: 'calc(90vh - 100px)' }}
          >
            {description && (
              <div className="sticky top-0 z-[9999] border-b border-gray-200 bg-white py-4 font-bold">
                {description}
              </div>
            )}
            <div>
              <h3 className="mb-4 text-lg font-medium text-gray-900">
                Input Schema
              </h3>
              <JsonDisplay data={input} />
            </div>

            <div>
              <h3 className="mb-4 text-lg font-medium text-gray-900">
                Output Schema
              </h3>
              <JsonDisplay data={output} />
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
